export * from './lib/edercare-data-access.module';
export * as EdercareActions from './lib/+state/edercare.actions';
export * as EdercareSelectors from './lib/+state/edercare.selectors';
export * as EdercareConstants from './lib/+state/edercare.constants';
export { EdercareService } from './lib/+state/edercare.service';
